import { StreamProtocol } from "../AlertViewModeTabs";

export const MINI_WALL_PAGE_SIZE = 9;
export const FOCUS_GRID_SIDE_PAGE_SIZE = 9;
export const EQUAL_GRID_PAGE_SIZE = 12;

// Wall GRID tiles always use HLS, never WHEP — a wall opens many tiles at once,
// and N concurrent WebRTC peer connections (each a full ICE negotiation over the
// single UDP NLB) flap and fail even while the relay sits idle. HLS is pull-based
// and cacheable, so it fans out to many tiles cheaply (2-3s latency is fine for a
// monitoring grid). The single focused/spotlight tile may still use WHEP for
// sub-second latency — that's only one connection.
export const WALL_GRID_PROTOCOL: StreamProtocol = "hls";

/** Matches Apply Filters / actuate button corner radius (`rounded`). */
export const VIDEO_FRAME_ROUNDED_CLASS = "overflow-hidden rounded";
export const VIDEO_FRAME_CLASS = `${VIDEO_FRAME_ROUNDED_CLASS} border-2 bg-black`;
